import { formatUsd } from './pulseTotals.js'
import type { PulseOpen } from './pulseDrawer.js'

type Totals = ReturnType<typeof import('./pulseTotals.js').pulseTotals>
type Status = ReturnType<typeof import('./pulseTotals.js').pulseStatus>

export default function PulseTotalsBlock({
  totals,
  status,
  typicalLine,
  onOpen,
  onAskSoren,
}: {
  totals: Totals
  status: Status
  typicalLine?: string
  onOpen: (next: PulseOpen) => void
  onAskSoren: () => void
}) {
  return (
    <>
      <div className="pulse-kicker">Current project snapshot</div>
      <div className="pulse-totals">
        <button type="button" className="pulse-total" data-testid="pulse-total-revised" onClick={() => onOpen({ kind: 'payments' })}>
          <div className="pulse-total-label">Revised contract</div>
          <div className="pulse-total-value">{formatUsd(totals.revised)}</div>
          <div className="pulse-total-sub">{formatUsd(totals.original)} + {formatUsd(totals.changeOrders)} COs</div>
        </button>
        <button type="button" className="pulse-total" data-testid="pulse-total-billed" onClick={() => onOpen({ kind: 'payments' })}>
          <div className="pulse-total-label">Billed</div>
          <div className="pulse-total-value">{formatUsd(totals.billed)}</div>
          <div className="pulse-total-sub">G702 work to date</div>
        </button>
        <button type="button" className="pulse-total" data-testid="pulse-total-retainage-held" onClick={() => onOpen({ kind: 'payments', highlight: 'retainage' })}>
          <div className="pulse-total-label">Retainage held</div>
          <div className="pulse-total-value">{formatUsd(totals.held)}</div>
        </button>
        <button type="button" className="pulse-total" data-testid="pulse-total-collected" onClick={() => onOpen({ kind: 'payments', highlight: 'received' })}>
          <div className="pulse-total-label">Collected</div>
          <div className="pulse-total-value">{formatUsd(totals.collected)}</div>
        </button>
        <button type="button" className="pulse-total" data-testid="pulse-total-open" onClick={() => onOpen({ kind: 'payments' })}>
          <div className="pulse-total-label">Open</div>
          <div className="pulse-total-value">{formatUsd(totals.open)}</div>
          <div className="pulse-total-sub">Billed − held − collected</div>
        </button>
      </div>
      <div className="pulse-statusbar">
        <p className="pulse-status" data-testid="pulse-status-line">{status.line}</p>
        {typicalLine ? <p className="pulse-pay-typical" data-testid="pulse-pay-typical">{typicalLine}</p> : null}
        <p className="pulse-sentence" data-testid="pulse-status-sentence">{status.sentence}</p>
        <div className="pulse-mini">
          <button type="button" className="btn b-ol btn-sm" onClick={() => onOpen({ kind: 'payments', highlight: 'retainage' })}>View retainage</button>
          <button type="button" className="btn b-ol btn-sm" data-testid="pulse-ask-soren" onClick={onAskSoren}>Ask Soren</button>
        </div>
      </div>
    </>
  )
}
